module.exports = __webpack_public_path__ + "static/activision-blizzard-logo-7447b4a2d692e7fad0d3480be2d31e6c.png";